module.exports = __webpack_public_path__ + "static/media/bo.eab17936.svg";